module.exports = __webpack_public_path__ + "static/media/vipin.d1eaec34.jpg";